import { AppDispatch, RootState } from "@store/store";
import { MenuItem } from "@dto/MenuItem";
import {
  setLastMenuItemAction,
  setMenuItemAction as setMenuItem,
  setSelectedCategoryIdsAction,
  setSelectedExclusiveCategoryIdsAction,
} from "../menuItemReducer";

const setMenuItemAction =
  (menuItem: MenuItem) =>
  (dispatch: AppDispatch, _getState: () => RootState) => {
    dispatch(setMenuItem(menuItem));
    dispatch(setLastMenuItemAction(menuItem));
    dispatch(setSelectedCategoryIdsAction([]));
    dispatch(setSelectedExclusiveCategoryIdsAction([]));
  };

export { setMenuItemAction };
